import React, { useState, useEffect } from "react";
import { DatePicker } from "antd";
import { Link } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import moment from "moment/moment";
 

const NotifyRequestor = ({ sampleRequestDetails, completedDonorDetails, notifyRequestor }) => {
    const [pickupTime, setPickupTime] = useState(null);
    const [isNotify, setIsNotify] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [timeSlots, setTimeSlots] = useState([]);
    const labHours = sampleRequestDetails?.lab?.lab_hours || [];


    useEffect(() => { 
        if (selectedDate) { 
//         const selectedDay = moment(selectedDate).format('dddd'); // Get day of the week, e.g., "Monday"

//         // Filter lab hours for the selected day
//         const hoursForDay = labHours.filter((lab) => lab.day === selectedDay);

//         // Generate time slots
//         const slots = [];
//         hoursForDay.forEach(({ open_at, close_at }) => {
//             const startTime = moment(open_at, 'HH:mm:ss');
//             const endTime = moment(close_at, 'HH:mm:ss');
//             while (startTime.isBefore(endTime)) {
//                 slots.push(startTime.format('HH:mm:ss')); // Store in 24-hour format
//                 startTime.add(30, 'minutes');
//             }
//         });
//         setTimeSlots(slots);

    // Generate 30-minute intervals for a 24-hour day
    const generateTimeSlots = () => {
        const slots = [];
        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 30) {
                // Format time as HH:mm:ss
                const formattedTime = `${hour.toString().padStart(2, "0")}:${minute
                    .toString()
                    .padStart(2, "0")}:00`;
                slots.push(formattedTime);
            }
        }
        return slots;
    };

    const timeSlots = generateTimeSlots();
    setTimeSlots(timeSlots);
        } else {
            setPickupTime(null);
            setTimeSlots([]); // Reset if no date is selected
        }
    }, [selectedDate]);
    

    useEffect(() => {  
        if (sampleRequestDetails?.request) {
            setIsNotify(
                sampleRequestDetails.request.is_notify === null
                    ? null
                    : sampleRequestDetails.request.is_notify
                    ? "Yes"
                    : "No"
            );
            
            setPickupTime(sampleRequestDetails.request?.pickup_time_notify);
            // Parse the date string 
            const parsedDate = moment(sampleRequestDetails.request?.pickup_date_notify);
            if (parsedDate.isValid()) {
                setSelectedDate(parsedDate);
            } else {
                console.error("Invalid date format:", sampleRequestDetails.request?.pickup_date_notify);
            }
        }
    }, [sampleRequestDetails]);

    const [isSubmitAttempted, setIsSubmitAttempted] = useState(false); // Tracks if the form is submitted

    const disabledDate = (current) => {
        return current && current < new Date().setHours(0, 0, 0, 0);
    };

    const validateForm = () => {
        const errors = {
            isNotifyError: null,
            selectedDateError: null,
            pickupTimeError: null,
        };

        if (isNotify == null) {
            errors.isNotifyError = "This field is required.";
        }
        if (isNotify === "Yes" && !selectedDate) {
            errors.selectedDateError = "This field is required.";
        }
        if (isNotify === "Yes" && !pickupTime) {
            errors.pickupTimeError = "This field is required.";
        }
        if (isNotify === "Yes" && !pickupTime && !selectedDate) {
            errors.pickupTimeError = "Field Pickup Date is required.";
        }
        return errors;
    };

    const saveAndNotify = () => { 
        setIsSubmitAttempted(true); // Mark the form as submitted
        const errors = validateForm();

        if (!errors.isNotifyError && !errors.selectedDateError && !errors.pickupTimeError) {
            // No errors, proceed with form submission

            const payload = {
                request_id: sampleRequestDetails?.request?.id,
                notify: isNotify.toLowerCase(),
                pickup_date: selectedDate?.format("YYYY-MM-DD"), // Format date to string
                pickup_time: pickupTime,
            };
            notifyRequestor(payload);
            
        } else {
            // Handle errors
            console.log("Validation errors:", errors);
        }
    };

    const errors = isSubmitAttempted ? validateForm() : {}; // Run validation only after submission

    return (
        <Accordion.Item eventKey="7">
            <Accordion.Header>
                <b>Notify Requestor</b>
            </Accordion.Header>
            <Accordion.Body>
                <label htmlFor="notify" className="form-label-check">
                    Would you like to notify the requestor that their samples are ready for pickup?
                </label>
                <div className="d-flex mt-1">
                    {["Yes", "No"].map((option) => (
                        <div className="form-check ms-2" key={option}>
                            <input
                                type="radio"
                                name="notify"
                                id={`notify_requestor_${option}`} 
                                value={option}
                                checked={isNotify === option}
                                onChange={() => setIsNotify(option)}
                                className="form-check-input radio-pointer"
                                autoComplete="off"
                            />
                            <label htmlFor={`notify_requestor_${option}`} className="form-check-label radio-pointer">&nbsp; {option}</label>
                        </div>
                    ))}
                </div>
                {isSubmitAttempted && errors.isNotifyError && (
                    <div className="text-danger">{errors.isNotifyError}</div>
                )}
<div dangerouslySetInnerHTML={{ __html: completedDonorDetails }}></div>

                {/* {completedDonorDetails} */}
                {isNotify === "Yes" && (
                    <div className="mt-3 row col-12 d-flex">
                        <div className="col-6">
                            <label>Pickup Date:</label>
                            <div className="form-group mt-1">
                                <DatePicker
                                    value={selectedDate}
                                    onChange={(date) => setSelectedDate(date)}
                                    // onChange={(date)=>handleDateChange(date)}
                                    disabledDate={disabledDate}
                                    format="YYYY-MM-DD"
                                    placeholder="Select a date"
                                    size="large"
                                    style={{width: '100%', height : '50px',     border: '1px solid grey'}}
                                />
                            </div>
                            {isSubmitAttempted && errors.selectedDateError && (
                                <div className="text-danger">{errors.selectedDateError}</div>
                            )}
                        </div>

                        <div className="col-6">
                            <div className="form-group">
                                <label>Pickup Time:</label>
                                <select
                                    name="pickupTime"
                                    value={pickupTime}
                                    onChange={(e) => setPickupTime(e.target.value)}
                                    className="form-select mt-1"
                                >
                                    <option value="">Select time</option>
                                    {timeSlots.map((slot) => (
                                        <option key={slot} value={slot}>
                                            {moment(slot, 'HH:mm:ss').format('h:mm A')} {/* Display label in 12-hour format */}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {isSubmitAttempted && errors.pickupTimeError && (
                                <div className="text-danger">{errors.pickupTimeError}</div>
                            )}
                        </div>

                    </div>
                )}
                <div className="d-flex mt-3">
                    <div>
                        <button onClick={saveAndNotify} className="el-main-button" type="button">
                            <span>Save and Notify</span>
                        </button>
                    </div>
                    <div>
                        <Link className="back-link" as={Link} to={`/admin/sample-requests`}>
                            <button className="el-main-button">
                                <span>Exit</span>
                            </button>
                        </Link>
                    </div>
                </div>
            </Accordion.Body>
        </Accordion.Item>
    );
};

export default NotifyRequestor;
